import '@/components/widgets/home/register'
import { DashboardFromConfig, type DashboardWidgetConfig } from '@/components/widgets/registry'
import { useShell } from '@/components/shell/shell-context'

/** CEO / leadership role template (FR-ORG-04) — entitlement-driven per persona in r0-authn. */
const CEO_DASHBOARD: DashboardWidgetConfig[] = [
  { widget: 'kpi-strip', span: 12 },
  { widget: 'journeys-board', span: 8 },
  { widget: 'active-incidents', span: 4 },
  { widget: 'security-rollup', span: 6 },
  { widget: 'tenant-movements', span: 6 },
  { widget: 'data-blindness-board', span: 12 },
]

export function Home() {
  const { env, range } = useShell()

  return (
    <div>
      <div className="mb-4 flex items-baseline justify-between">
        <div>
          <h1 className="text-[19px] font-bold tracking-tight">Home — CEO dashboard</h1>
          <p className="mt-0.5 text-[12.5px] text-ink-2">
            Role template: leadership · widget entitlement via RBAC (FR-ORG-04) · range: last {range} · env: {env}
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-3.5">
        <DashboardFromConfig config={[CEO_DASHBOARD[0]]} />
        <DashboardFromConfig config={CEO_DASHBOARD.slice(1, 3)} />
        <DashboardFromConfig config={CEO_DASHBOARD.slice(3, 5)} />
        <DashboardFromConfig config={[CEO_DASHBOARD[5]]} />
      </div>
    </div>
  )
}
